import { Link } from 'react-router-dom';
import { 
  Map, Building2, Ship, Landmark, Music 
} from 'lucide-react';

const categories = [
  { 
    name: 'Circuite Externe', 
    path: '/circuite', 
    icon: Map,
    image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=600'
  },
  { 
    name: 'Circuite România', 
    path: '/circuite-romania', 
    icon: Landmark,
    image: 'https://images.unsplash.com/photo-1635246678511-08d5ba58ac3a?w=600'
  },
  { 
    name: 'City Break', 
    path: '/city-break', 
    icon: Building2,
    image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600'
  },
  { 
    name: 'Croaziere', 
    path: '/croaziere', 
    icon: Ship,
    image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?w=600'
  },
  { 
    name: 'Concerte', 
    path: '/concerte', 
    icon: Music,
    image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=600'
  }
];

export const CategoryGrid = () => {
  return (
    <section className="py-16 md:py-24 bg-navy/50" data-testid="category-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-3">
            Descoperă ofertele
          </h2>
          <p className="text-white/60">
            Alege categoria preferată și găsește vacanța perfectă
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-6">
          {categories.map((cat, index) => {
            const Icon = cat.icon;
            return (
              <Link
                key={cat.path}
                to={cat.path}
                className="group relative h-48 md:h-56 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_30px_rgba(212,175,55,0.3)] animate-fade-in"
                style={{ animationDelay: `${index * 50}ms` }}
                data-testid={`category-card-${cat.name.toLowerCase().replace(' ', '-')}`}
              >
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/50 to-transparent" />
                <div className="absolute inset-0 z-[2] flex flex-col items-center justify-center p-4">
                  <div className="w-14 h-14 rounded-full bg-gold/20 backdrop-blur-sm flex items-center justify-center mb-3 group-hover:bg-gold/30 transition-all">
                    <Icon className="w-7 h-7 text-gold" />
                  </div>
                  <h3 className="font-heading font-semibold text-lg text-white text-center">
                    {cat.name}
                  </h3>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
